import { Light, LightType } from "./Light";
import { Vector3 } from "../../../maths/Vector3";
import { Laya3DRender } from "../../RenderObjs/Laya3DRender";
export class SpotLightCom extends Light {
    get direction() {
        return this._direction;
    }
    set direction(value) {
        value.cloneTo(this.direction);
        this._dataModule.setDirection(this._direction);
    }
    ;
    get spotAngle() {
        return this._dataModule.spotAngle;
    }
    set spotAngle(value) {
        this._dataModule.spotAngle = Math.max(Math.min(value, 179), 0);
    }
    get range() {
        return this._dataModule.spotRange;
    }
    set range(value) {
        this._dataModule.spotRange = value;
    }
    constructor() {
        super();
        this.spotAngle = 30.0;
        this.range = 10.0;
        this._direction = new Vector3();
        this._lightType = LightType.Spot;
    }
    _creatModuleData() {
        this._dataModule = Laya3DRender.Render3DModuleDataFactory.createSpotLight();
    }
    _addToLightQueue() {
        this.owner.scene._spotLights.add(this);
    }
    _removeFromLightQueue() {
        this.owner.scene._spotLights.remove(this);
    }
    _cloneTo(dest) {
        super._cloneTo(dest);
        dest.range = this.range;
        dest.spotAngle = this.spotAngle;
    }
}
